const TEMPLATE_QUERY_PARAM_KEY = 'from_chart';
const IS_CHART_TEMPLATE = 'is_template';

/**
 * Parses URL search string to extract chart template query parameters.
 * Returns whether the current view is a template and the source chart template key.
 */
export function getChartTemplateAdditionnalQueryParams(search: string) {
    const searchParams = new URLSearchParams(search);
    const isTemplate = searchParams.get(IS_CHART_TEMPLATE) === 'true';
    const chartTemplateValue = searchParams.get(TEMPLATE_QUERY_PARAM_KEY);
    // return null if the query param value does not exist
    return {
        isTemplate,
        chartTemplateKey: parseInt(chartTemplateValue || '', 10) || null,
    };
}

function setChartTemplateKeyQueryParamIfExists(
    currentSearch: string,
    value: string | number | null,
) {
    if (!value) return currentSearch;
    return `${currentSearch}&${TEMPLATE_QUERY_PARAM_KEY}=${value}`;
}

/**
 * Appends chart template query parameters to an existing search string.
 * Sets the source template key and marks the view as a template if applicable.
 */
export function setChartTemplateAdditionnalQueryParams(
    currentSearch: string,
    value: string | number | null,
    isChartTemplate: boolean,
) {
    return `${setChartTemplateKeyQueryParamIfExists(currentSearch, value)}${
        isChartTemplate ? `&${IS_CHART_TEMPLATE}=true` : ''
    }`;
}
